// extracted by mini-css-extract-plugin
export default {"Assistance":"Assistance_Assistance__rS6SS","list":"Assistance_list__SA4Vk","view-more":"Assistance_view-more__Nycsh"};